export const enum PContentsMutationsNames {
    SetList = "setProgramContentsList",
    SetSelected = "setSelectedProgramContent",
    SetError = "setProgramContentsError",
    ResetState = "resetState",
}

export const enum PContentsActionsNames {
    FetchList = "fetchProgramContentsList",
    SetSelected = "setSelectedProgramContent",
    ResetState = "resetProgramContentsState",
}

export const enum PContentsGettersNames {
    ProgramContentsList = "programContentsList",
    SelectedAsset = "selectedProgramContent",
    ProgramContentsError = "error",
}
